import React, { useState, useEffect } from "react";
import styled from "@emotion/styled/macro";
import countries from "country-data";

//import TextInput from "../common/TextInput";
import PhoneNumberInput from "../common/PhoneNumberInput";
import FormField from "./FormField";

const Fields = styled("div")`
  display: flex;
  justify-content: space-between;
  padding: 0 24px;
`;

/*const CodeField = styled(FormField)`
  width: 23.1%;
`;*/

const PhoneNumberField = styled(FormField)`
  width: 90%;
`;

const countryCodeMap = Object.keys(countries.callingCountries).reduce(
  (obj: any, key) => {
    const { alpha2, countryCallingCodes } = countries.callingCountries[key];
    (countryCallingCodes || []).forEach(code => {
      obj[code] = alpha2;
    });
    return obj;
  },
  {}
);

export interface IPhoneData {
  countryCode: string | null;
  phoneNumber: string | null;
  formattedPhoneNumber: string;
}

interface IProps {
  initialCountryCode?: string;
  initialPhoneNumber?: string;
  onChange: (value: IPhoneData) => void;
  disabled?: boolean;
  autoFocus?: boolean;
}

export default function PhoneNumberFields({
  initialCountryCode = "1",
  initialPhoneNumber = "",
  disabled = false,
  autoFocus = true,
  onChange
}: IProps) {
  const [countryCode, setCountryCode] = useState(initialCountryCode);
  //const [countryCodeBlurred, setCountryCodeBlurred] = useState(false);
  //const [countryCodeChanged, setCountryCodeChanged] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(initialPhoneNumber);
  const [formattedPhoneNumber, setFormattedPhoneNumber] = useState("");
  const [phoneNumberBlurred, setPhoneNumberBlurred] = useState(false);
  const [phoneNumberChanged, setPhoneNumberChanged] = useState(false);

  const regionCode = countryCodeMap[`+${countryCode}`];
  const phoneNumberIsValid = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(phoneNumber);
  const countryCodeIsValid = regionCode != null;

  useEffect(() => {
    onChange({
      countryCode: countryCodeIsValid ? countryCode : null,
      phoneNumber: phoneNumberIsValid ? phoneNumber : null,
      formattedPhoneNumber
    });
  });

  return (
    <Fields>
      {/*<CodeField>
        <label htmlFor="countryCode">Code</label>
        <TextInput
          id="countryCodeId"
          value={`+${countryCode}`}
          disabled={disabled}
          isValid={
            !countryCodeBlurred || !countryCodeChanged || countryCodeIsValid
          }
          onChange={e => {
            setCountryCode((e.target.value || "+").slice(1));
            setCountryCodeChanged(true);
          }}
          onBlur={e => {
            setCountryCodeBlurred(true);
          }}
        />
        </CodeField>*/}
      <PhoneNumberField>
        <label htmlFor="emailId">Email Address*</label>
        <PhoneNumberInput
          id="emailId"
          value={phoneNumber}
          disabled={disabled}
          autoFocus={autoFocus}
          isValid={
            !phoneNumberBlurred || !phoneNumberChanged || phoneNumberIsValid
          }
          placeholder="example@provider.com"
          onChange={(e: any) => {
            const value = e.target.value.replace(" ", "");
            // setPhoneNumber(e.target.rawValue);
            setPhoneNumber(value);
            setFormattedPhoneNumber(value);
            setPhoneNumberChanged(true);
          }}
          onBlur={() => {
            setPhoneNumberBlurred(true);
          }}
          //regionCode={regionCode}
        />
      </PhoneNumberField>
    </Fields>
  );
}
